import CircularProgressMaterial from '@mui/material/CircularProgress';
import React from 'react';

function CircularProgress(props: any) {
  return <CircularProgressMaterial {...props} color={props.color || 'secondary'} />;
}

export default CircularProgress;
